import { useEffect } from 'react';

interface Entrada {
  url: string;
  refs: number;
  timer?: ReturnType<typeof setTimeout>;
}

/** Una sola URL per blob, compartida entre components i revocada quan ningú no la fa servir. */
const cache = new WeakMap<Blob, Entrada>();

function entrada(blob: Blob): Entrada {
  let e = cache.get(blob);
  if (!e) {
    e = { url: URL.createObjectURL(blob), refs: 0 };
    cache.set(blob, e);
  }
  return e;
}

const disponible = () => typeof URL.createObjectURL === 'function';

/** URL `blob:` d'un fitxer o blob; es revoca quan canvia o quan el component es desmunta. */
export function useObjectUrl(blob: Blob | null | undefined): string | null {
  const url = blob && disponible() ? entrada(blob).url : null;
  useEffect(() => {
    if (!blob || !disponible()) return;
    const e = entrada(blob);
    e.refs += 1;
    if (e.timer) clearTimeout(e.timer);
    return () => {
      e.refs -= 1;
      // Es difereix perquè un remuntatge immediat (StrictMode) la pugui reaprofitar.
      e.timer = setTimeout(() => {
        if (e.refs > 0) return;
        URL.revokeObjectURL(e.url);
        if (cache.get(blob) === e) cache.delete(blob);
      }, 0);
    };
  }, [blob]);
  return url;
}
